<template>
  <v-card class="panelBlock policies-and-terms">
    <v-layout row wrap>
      <v-flex tag="h2" xs12>{{ myToolsConstants.POLICIES_TERMS }}</v-flex>
      <v-flex class="resources inner-scrollbar">
        <v-flex
            v-for="(heading, index1) in policiesAndTerms.privacyPolicy" :key="heading.name"
            class="resources__list-items">
          <span v-if="heading.name === 'Community Standards'" :id="`policies_unitTest_${index1}`">
              <a :data-qe-id="'resourcesMenu_'+index1"
                 :href="heading.url" :target="linkTarget" class="urls">{{ heading.name }} </a>
          </span>
          <span v-if="heading.name.toLowerCase() === myToolsConstants.NETWORK_TERMS_CONDITIONS" :id="`policies_unitTest_${index1}`">
              <a :data-qe-id="'resourcesMenu_'+index1"
                 :href="networkTermsAndConditions(heading.url)" :target="linkTarget" class="urls">{{ heading.name }} </a>
          </span>
          <span v-if="heading.name !== 'Community Standards' && heading.name.toLowerCase() !== myToolsConstants.NETWORK_TERMS_CONDITIONS">
              <a :data-qe-id="'resourcesMenu_'+index1" :href="heading.url" class="urls"
              :target="getTarget(heading.name)">{{ heading.name }} </a>
          </span>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { myToolsConstants } from "../mytools.constant";
import { policiesAndTerms } from "../../MyAccount/privacysettings.constants";
import { mapGetters } from "vuex";
import { storeGetters } from '@/store/storeGetters.constant';
import { routerNames } from '../../appCommon.constants';
import { commonEnvVariables } from "@/commonEnvVariables";

export default {
  name: "PoliciesTerms",
  data: () => ({
    policiesAndTerms,
    myToolsConstants,
    menuPanel: [],
    routerNames,
    commonEnvVariables,
  }),

  directives: {
    ClickOutside,
  },
  props: {
    showHideTools: {
      type: Function,
      required: false,
    },
  },

  methods: {
    none() {
      this.menuPanel = -1;
    },
    getTarget(name) {
      return name.toLowerCase() === 'policies & procedures' && this.isMobileAppBrowser
          ? "_self"
          : "_blank";
    },
    networkTermsAndConditions(url) {
      if (this.$route.name === this.routerNames.NETWORK
          && this.communityInfo
          && this.communityInfo.communityId === this.$route.params.communityId
          && this.$route.params.communityId.toLowerCase() === this.commonEnvVariables().BUSINESS_MARKETPLACE_COMMUNITY_ID
          && this.communityInfo.communitySubType.toLowerCase() === this.myToolsConstants.BUSINESS_COMMUNITY_TYPE) {
        return this.commonEnvVariables().BUSINESS_MARKETPLACE_COMMUNITY_URL;
      } else {
        return url;
      }
    }
  },

  computed: {
    ...mapGetters({
      resourceLinks: `tools/${storeGetters.resourceLinks}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
      communityInfo: `chapter/${[storeGetters.communityInfo]}`,
    }),
    linkTarget() {
      return this.isMobileAppBrowser ? '_self' : '_blank';
    },
  },

  watch: {
    resourceLinks() {
      if (this.resourceLinks && this.resourceLinks.length && this.resourceLinks.length >= 7) {
        this.resourceLinks[6].forEach((subElement) => {
          this.policiesAndTerms.privacyPolicy.forEach((item) => {
            if (subElement.name.toLowerCase() === item.name.toLowerCase()) {
              item.url = subElement.url;
            }
            if (subElement.name.toLowerCase() === item.name2.toLowerCase()) {
              item.url2 = subElement.url;
            }
          });
        });
      }
    },
  },

};
</script>

<style lang="scss">
@import "../../../common/styles/_colors.scss";
@import "../../../common/styles/_responsive.scss";

.policies-and-terms {
  .resources {
    border: none;
    margin: 0;

    .left-heading {
      padding: 20px 0 20px 20px;
      color: $ypo-cta;
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      background: $white;
      border-top: 1px solid $ypo-extra-light-gray;
      text-align: left;
    }

    &-social {
      text-align: center;
      background: $white;
      padding-bottom: 10px;

      span {
        display: inline-block;
        margin: 0 13px;
        font-size: 24px;

        a {
          color: $ypo_blue;
          transition: 0.2s;

          &:hover {
            color: $ypo-cta;
          }
        }
      }

      &__single {
        text-align: center;
        background: $white;
        padding: 5px 0 15px 0;

        a {
          color: $ypo-cta;
          font-size: 12px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    &__list-items {
      border-top: 1px solid $ypo-medium-gray;
      padding: 15px 10px;
      margin: 0 5px;

      .urls {
        margin: 0 !important;
      }

      &__info {
        color: $ypo-gold !important;
        font-weight: 600 !important;
      }

      &:first-of-type {
        border: none;
      }

      &:last-of-type {
        margin: 0;
        background-color: $ypo-primary-blue;
        padding: 15px;

        .urls {
          color: $white;
          font-weight: 600;
        }
      }
    }

    .heading {
      color: $ypo-cta;
      font-size: 14px;
      font-weight: bold;
      line-height: 18px;
    }

    .urls {
      text-decoration: none;
      transition: 0.3s;
      font-size: 14px;
      font-weight: 500;
      color: $ypo-cta;
      margin-top: 15px;
      display: inline-block;
      margin-left: 20px;

      &:hover {
        text-decoration: underline;
        color: $ypo_blue;
      }
    }

    &__list {
      &:first-child {
        padding-top: 20px;
      }
    }

    .v-expansion-panel {
      box-shadow: none;

      &__container {
        border-top: 1px solid $ypo-extra-light-gray !important;

        &__main {
          position: relative;
          transition: 2s;

          &:hover {
            background: $ypo-extra-light-gray;
          }
        }

        .v-expansion-panel__header {
          padding: 10px 15px;
          min-height: inherit;
          position: relative;
          background: $white;
        }

        &--active {
          background: $ypo-extra-light-gray;
          position: relative;

          &.url-links {
            padding: 5px 30px 10px 30px;
            background: transparent;
          }

          .v-expansion-panel__header {
            background: $white;

            .heading {
              color: $ypo_blue;
            }
          }

          .v-expansion-panel__body {
            background: rgba($ypo-cta, 0.03);
            padding-bottom: 20px;

            .v-card {
              background: transparent;
            }
          }
        }
      }
    }
  }
}
</style>
